
@if(data.contentTemplate){
    <mat-dialog-content class="dilog-cont">
        <ng-container
            style="height: max-content;"
            [ngTemplateOutlet]="data.contentTemplate"
            [ngTemplateOutletContext]="{ $implicit: data.context || {} }">
        </ng-container>
    </mat-dialog-content>
} @else {
    <h3>Something went wrong!</h3>
}
